const DashboardLandingPageCell = ({ orgId }: { orgId: string }) => {
  return (
    <div
      className='card card card-xl-stretchcard_borderC'
      style={{ backgroundColor: '#ffff', width: '100%', height: '100%', textAlign: 'center' }}
    >
      {/* begin::Body */}
      <div className='card-body d-flex flex-column align-items-center'>
        <span className='text-dark fs-2hx mb-3'>Del landingssiden</span>
        <span className='fs-3 mb-3'>
          Vi har laget en landingsside for din organisasjon. Denne kan enkelt deles på sosiale
          medier slik at støttespillerne dine kommer rett inn i din organisasjon i støtte.
        </span>
        <iframe
          src={`https://finn.stotte.no/org_${orgId}`}
          style={{
            width: '60%',
            height: '80%',
            border: 'none',
            borderRadius: '8px',
            zoom: '0.35',
          }}
          title='Landingsside preview'
        />
      </div>
    </div>
  )
}

export { DashboardLandingPageCell }
